import z from 'zod'

import { counterStyles } from 'features/globalSetup/api/types/counterStyle'
import { invalidAdDisplaysBeforeRefreshError } from 'features/globalSetup/constants'
import { adDisplaysBeforeRefreshValues } from 'features/globalSetup/types/adDisplaysBeforeRefresh'
import { validateJSONSchema } from 'utils/json'
import { RichPlacementMultiAnchor } from '../../hooks/useGetRichPlacementMultiAnchor'

const adDisplaysBeforeRefreshValuesSchema = z.enum(adDisplaysBeforeRefreshValues)

export const schema = z.object({
  counterStyle: z.enum(counterStyles).default('progressBar'),
  customStyling: z.string().superRefine(validateJSONSchema),
  desktopAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.default('2'),
  desktopSingleAdViewTime: z.number().int().min(2_000).default(5_000),
  displayAfterUserInteraction: z.boolean().default(false),
  frequencyCappingEnabled: z.boolean().default(false).optional(),
  fullWidthMode: z.boolean().default(false),
  impressionLimit: z.number().min(1).max(100).default(1).optional(),
  mobileAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.default('2'),
  mobileSingleAdViewTime: z.number().int().min(2_000).default(5_000),
  showCloseButton: z.boolean().default(false),
  timeWindow: z.number().min(1).max(1_440).default(60).optional(),
})

export type Schema = z.infer<typeof schema>

export const schemaDefault = (multiAnchor: RichPlacementMultiAnchor): Schema => {
  const {
    counterStyle,
    customStyling,
    desktopAdDisplaysBeforeRefresh,
    desktopSingleAdViewTime,
    displayAfterUserInteraction,
    frequencyCappingEnabled,
    fullWidthMode,
    impressionLimit,
    mobileAdDisplaysBeforeRefresh,
    mobileSingleAdViewTime,
    showCloseButton,
    timeWindow,
  } = multiAnchor

  return {
    counterStyle,
    customStyling,
    desktopAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.parse(
      String(desktopAdDisplaysBeforeRefresh),
      { error: () => invalidAdDisplaysBeforeRefreshError },
    ),
    desktopSingleAdViewTime,
    displayAfterUserInteraction,
    frequencyCappingEnabled,
    fullWidthMode,
    impressionLimit,
    mobileAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.parse(
      String(mobileAdDisplaysBeforeRefresh),
      { error: () => invalidAdDisplaysBeforeRefreshError },
    ),
    mobileSingleAdViewTime,
    showCloseButton,
    timeWindow,
  }
}
